import axios from 'axios';
import { CONFIG } from './config';
const $erroMess = (message, duration = 2000) => {
  if (window.Vue && window.Vue.$message) {
    window.Vue.$message({
      message,
      customClass: 'bom_center_message',
      duration,
      type: 'warning'
    });
  }
};
const DEBUG = process.env.NODE_ENV !== 'production';
const headers = {
  'Content-Type': 'application/json'
};
import TradingStore from '../../store';

const tradingHttpHandler = async (method, url, data, option) => {
  if (TradingStore.state.token) {
    headers.Authorization = 'JWT ' + TradingStore.state.token;
  }
  let AXIOSRES = null;
  let baseURL = CONFIG.API_URL;
  if (option && option.baseURL === 'res') {
    baseURL = CONFIG.RES_URL;
  }
  if (option && option.baseURL === 'up') {
    baseURL = CONFIG.DATA_API_UPURL;
  }
  try {
    AXIOSRES = await axios.request({
      baseURL,
      headers,
      method,
      url,
      params: method === 'get' ? data : null,
      data: method === 'post' ? data : null,
      timeout: DEBUG ? 100000 : 30000
    });
    if (AXIOSRES.status !== 200 || AXIOSRES.data.Code !== 200) {
      throw new Error('网络异常，请稍后再试');
    } else {
      const Result = AXIOSRES.data.Result;
      if (Result.isSuccess || Result.Code === 0) {
        return Result.Data;
      } else {
        throw new Error(Result.Message);
      }
    }
  } catch (error) {
    $erroMess(error && error.message ? error.message : error);
  }
};

const tradingHttpGet = (url, data, option) => {
  return tradingHttpHandler('get', url, data, option);
};
const tradingHttpPost = async (url, data, option) => {
  return await tradingHttpHandler('post', url, data, option);
};

export {
  tradingHttpHandler,
  tradingHttpGet as httpGet,
  tradingHttpPost as httpPost
};
